// extracted by mini-css-extract-plugin
module.exports = {"isUpdate":"styles_isUpdate__1C0Io","index":"styles_index__38COT","content":"styles_content__3Hj3c"};